import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { LogoImage } from "@/components/Logo";
export const Footer = () => (
  <footer data-testid="footer" className="relative z-10 bg-brand-navy text-white">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20">
      <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
        <div>
          <LogoImage className="inline-block h-24" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            The growth partner for small businesses ready to win online. Websites, SEO, social, ads, email & reputation — all under one roof.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Company</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-300">
            <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
            <li><Link to="/templates" className="hover:text-white transition-colors">Templates</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-white transition-colors">Client Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Get in touch</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-300">
            <li>joellegend247@gmail.com</li>
            <li>(970) 746-3660</li>
            <li>
              <Link to="/contact" className="inline-flex items-center gap-1 font-semibold text-white">
                Start a project <ArrowUpRight className="h-4 w-4" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} Massive Growth Marketing. All rights reserved.</p>
        <p>Small businesses. Massive results.</p>
      </div>
    </div>
  </footer>
);
